import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const VCIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="VC" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#FFDC17"
        fillRule="evenodd"
        d="M4 0h8v12H4V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#5FBF2B"
        fillRule="evenodd"
        d="M12 0h4v12h-4V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#2E42A5"
        fillRule="evenodd"
        d="M0 0h4v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#5FBF2B"
        d="M9.462 7.194 8.06 9.45 6.42 7.194l1.64-2.192 1.4 2.192Zm1.92-2.463L9.864 6.884 8.343 4.73 9.863 2.5l1.52 2.231Zm-3.842 0L6.02 6.845 4.5 4.73 6.139 2.54 7.54 4.731Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
